import { render, staticRenderFns } from "./AmsSearch.vue?vue&type=template&id=18769872&"
import script from "./AmsSearch.vue?vue&type=script&lang=js&"
export * from "./AmsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports